import { Box, HStack, List, ListItem, Text } from "@chakra-ui/react";

export type RoadColorAndType = {
  lineColor: string;
  roadType: string;
};

export const RouteUsageGuide = () => {
  const roadColorAndType: RoadColorAndType[] = [
    { lineColor: "#FF4500", roadType: "オプションの経由地に寄らない経路" },
    { lineColor: "#81C784", roadType: "オプションの経由地に寄る経路" },
    { lineColor: "#1E6CF2", roadType: "走行メモの経路" },
  ];

  return (
    <Box bgColor={"#EEEEEE"} p={1}>
      <List>
        {roadColorAndType.map((road, idx) => (
          <ListItem py={2} key={idx}>
            <HStack>
              <Box
                height={2}
                width={10}
                bgColor={road.lineColor}
                rounded={10}
              ></Box>
              <Text fontSize={"md"}>{road.roadType}</Text>
            </HStack>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
